import { render, staticRenderFns } from "./SMSBrandingForm.vue?vue&type=template&id=9f58c442&scoped=true&"
import script from "./SMSBrandingForm.vue?vue&type=script&lang=js&"
export * from "./SMSBrandingForm.vue?vue&type=script&lang=js&"
import style0 from "./SMSBrandingForm.vue?vue&type=style&index=0&id=9f58c442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58c442",
  null
  
)

export default component.exports